import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { alignItems, borderRadius, display, height } from 'styled-system';
import type { AlignItemsProps, BorderRadiusProps, DisplayProps, HeightProps } from 'styled-system';

import { useLocalization } from '../../providers/LocaleProvider';
import type { AsProps, TextDecorationProps } from '../../theme/system-utilities';
import { textDecoration } from '../../theme/system-utilities';
import { Button } from '../Button';
import { LinkRegularLR1 } from '../Typography';

interface CategoryShowMoreProps {
  onClick: () => void;
  expanded: boolean;
  className?: string;
}

const ShowMore = styled(Button)<
  TextDecorationProps & AsProps & HeightProps & DisplayProps & AlignItemsProps & BorderRadiusProps
>`
  ${textDecoration};
  ${height};
  ${display};
  ${alignItems}
  ${borderRadius}

  &:hover {
    text-decoration: underline;
  }
`;

const showMoreStyles: ComponentProps<typeof ShowMore> = {
  textDecoration: 'underline',
  type: 'button',
  kind: 'bare',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  borderRadius: 'medium',
};

const CategoryShowMore = ({ expanded, onClick, className }: CategoryShowMoreProps) => {
  const { t } = useLocalization();

  return (
    <ShowMore
      {...showMoreStyles}
      onClick={onClick}
      data-testid="show-more-button"
      className={className}
    >
      <LinkRegularLR1 as="span" color="sys.neutral.text.default">
        {expanded ? t('h24_show_less') : t('h24_show_more')}
      </LinkRegularLR1>
    </ShowMore>
  );
};

export default CategoryShowMore;
